
// import React, { useState,useEffect } from 'react';
// import { Lock, Eye, EyeOff, CheckCircle, XCircle, Shield } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify'; // Import toast

// import '../../Dashboard Style/ChangePassword.css';
// import Sidebar from '../Core/Sidebar';
// import Navbar from '../Core/Navbar';
// import { useSelector } from 'react-redux';

// const ChangePassword = () => {
//   const token = useSelector((state) => state.user?.token);
//   const navigate = useNavigate();
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const [formData, setFormData] = useState({
//     currentPassword: '',
//     newPassword: '',
//     confirmPassword: ''
//   });
//   const [showPassword, setShowPassword] = useState({
//     current: false,
//     new: false,
//     confirm: false
//   });
//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [apiError, setApiError] = useState('');
//   const [success, setSuccess] = useState(false);
  
//   // Password strength criteria
//   const [passwordCriteria, setPasswordCriteria] = useState({
//     length: false,
//     uppercase: false,
//     lowercase: false,
//     number: false,
//     specialChar: false
//   });

//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   // Initialize sidebar functionality (same as in Dashboard)
//   useEffect(() => {
//     const sidebar = document.querySelector('.sidebar');
//     const sidebarBody = document.querySelector('.sidebar-body');
    
//     if (sidebar) {
//       if (sidebarOpen) {
//         sidebar.classList.remove('close');
//       } else {
//         sidebar.classList.add('close');
//       }
//     }
    
//     // Add custom scrollbar to sidebar body
//     if (sidebarBody) {
//       sidebarBody.style.height = 'calc(100vh - 70px)';
//       sidebarBody.style.overflowY = 'auto';
//     }

//     return () => {
//       // Cleanup
//     };
//   }, [sidebarOpen]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));

//     // Clear field error
//     if (errors[name]) {
//       setErrors(prev => ({ ...prev, [name]: '' }));
//     }

//     // Validate password criteria for new password
//     if (name === 'newPassword') {
//       setPasswordCriteria({
//         length: value.length >= 8,
//         uppercase: /[A-Z]/.test(value),
//         lowercase: /[a-z]/.test(value),
//         number: /[0-9]/.test(value),
//         specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(value)
//       });
//     }
//   };

//   const togglePasswordVisibility = (field) => {
//     setShowPassword(prev => ({
//       ...prev,
//       [field]: !prev[field]
//     }));
//   };

//   const validateForm = () => {
//     const newErrors = {};

//     if (!formData.currentPassword.trim()) {
//       newErrors.currentPassword = 'Current password is required';
//     }

//     if (!formData.newPassword.trim()) {
//       newErrors.newPassword = 'New password is required';
//     } else if (formData.newPassword.length < 8) {
//       newErrors.newPassword = 'Password must be at least 8 characters';
//     } else if (!passwordCriteria.uppercase || 
//                !passwordCriteria.lowercase || 
//                !passwordCriteria.number || 
//                !passwordCriteria.specialChar) {
//       newErrors.newPassword = 'Password does not meet all requirements';
//     }

//     if (!formData.confirmPassword.trim()) {
//       newErrors.confirmPassword = 'Please confirm your password';
//     } else if (formData.confirmPassword !== formData.newPassword) {
//       newErrors.confirmPassword = 'Passwords do not match';
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setApiError('');
//     setSuccess(false);

//     if (!validateForm()) {
//       return;
//     }

//     setLoading(true);

//     try {
//       const formBody = new URLSearchParams({
//         current_password: formData.currentPassword,
//         new_password: formData.newPassword,
//         confirm_password: formData.confirmPassword
//       });

//       const response = await fetch('https://global.thewillowquantum.com/api/user/change-password', {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Accept': 'application/json',
//           'Content-Type': 'application/x-www-form-urlencoded',
//         },
//         body: formBody
//       });

//       const result = await response.json();

//       if (result.status) {
//         setSuccess(true);
//         setFormData({
//           currentPassword: '',
//           newPassword: '',
//           confirmPassword: ''
//         });
//         setPasswordCriteria({
//           length: false,
//           uppercase: false,
//           lowercase: false,
//           number: false,
//           specialChar: false
//         });
        
//         // Show success toast
//         toast.success('Password changed successfully! Redirecting to profile...');
        
//         // Auto redirect after 3 seconds
//         setTimeout(() => {
//           setSuccess(false);
//           navigate('/profile');
//         }, 3000);
//       } else {
//         const errorMsg = result.message || 'Failed to change password. Please try again.';
//         setApiError(errorMsg);
//         toast.error(errorMsg);
//       }
//     } catch (error) {
//       console.error('Password change error:', error);
//       const errorMsg = 'An error occurred. Please try again.';
//       setApiError(errorMsg);
//       toast.error(errorMsg);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const passwordStrength = () => {
//     const metCriteria = Object.values(passwordCriteria).filter(Boolean).length;
//     const totalCriteria = Object.keys(passwordCriteria).length;
//     return (metCriteria / totalCriteria) * 100;
//   };

//   const getPasswordStrengthColor = () => {
//     const strength = passwordStrength();
//     if (strength <= 40) return '#ef4444';
//     if (strength <= 80) return '#f59e0b';
//     return '#10b981';
//   };

//   return (
//    <div className="main-wrapper dark-theme">
//       {/* Sidebar */}
//       <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
//         <div className="sidebar-header">
//           <a href="#" className="sidebar-brand">
//             <i className="me-2" data-lucide="atom"></i>
//             Willow <span>Quantum</span>
//           </a>
//           <div className="sidebar-toggler" onClick={toggleSidebar}>
//             <span></span>
//             <span></span>
//             <span></span>
//           </div>
//         </div>
//         <Sidebar />
//       </nav>

//       <div className="page-wrapper">
//         {/* Navbar - Update to pass toggleSidebar prop */}
//         <Navbar toggleSidebar={toggleSidebar} />
        
//         {/* Page Content */}
//         <div className="page-content-wrapper">
//           <div className="willow-change-password-page">
//             <div className="willow-change-password-container">
//               <div className="willow-change-password-card">
//                 {/* Header */}
//                 <div className="willow-change-password-header">
//                   <div className="willow-change-password-header-icon">
//                     <Shield size={32} />
//                   </div>
//                   <h1 className="willow-change-password-title">Change Password</h1>
//                   <p className="willow-change-password-subtitle">
//                     Secure your account by updating your password regularly
//                   </p>
//                 </div>

//                 {/* Success Message */}
//                 {success && (
//                   <div className="willow-change-password-success-alert">
//                     <CheckCircle size={20} />
//                     <div>
//                       <strong>Password Changed Successfully!</strong>
//                       <p>You will be redirected to your profile page shortly.</p>
//                     </div>
//                   </div>
//                 )}

//                 {/* Error Message */}
//                 {apiError && (
//                   <div className="willow-change-password-error-alert">
//                     <XCircle size={20} />
//                     <div>
//                       <strong>Error</strong>
//                       <p>{apiError}</p>
//                     </div>
//                   </div>
//                 )}

//                 {/* Form */}
//                 <form onSubmit={handleSubmit} className="willow-change-password-form">
//                   {/* Current Password */}
//                   <div className="willow-change-password-form-group">
//                     <label htmlFor="currentPassword" className="willow-change-password-label">
//                       <Lock size={16} />
//                       Current Password
//                     </label>
//                     <div className="willow-change-password-input-wrapper">
//                       <input
//                         type={showPassword.current ? "text" : "password"}
//                         id="currentPassword"
//                         name="currentPassword"
//                         value={formData.currentPassword}
//                         onChange={handleInputChange}
//                         placeholder="Enter your current password"
//                         className={`willow-change-password-input ${errors.currentPassword ? 'willow-change-password-input-error' : ''}`}
//                         disabled={loading}
//                       />
//                       <button
//                         type="button"
//                         className="willow-change-password-toggle-btn"
//                         onClick={() => togglePasswordVisibility('current')}
//                         disabled={loading}
//                       >
//                         {showPassword.current ? <EyeOff size={18} /> : <Eye size={18} />}
//                       </button>
//                     </div>
//                     {errors.currentPassword && (
//                       <span className="willow-change-password-error-msg">{errors.currentPassword}</span>
//                     )}
//                   </div>

//                   {/* New Password */}
//                   <div className="willow-change-password-form-group">
//                     <label htmlFor="newPassword" className="willow-change-password-label">
//                       <Lock size={16} />
//                       New Password
//                     </label>
//                     <div className="willow-change-password-input-wrapper">
//                       <input
//                         type={showPassword.new ? "text" : "password"}
//                         id="newPassword"
//                         name="newPassword"
//                         value={formData.newPassword}
//                         onChange={handleInputChange}
//                         placeholder="Create a strong new password"
//                         className={`willow-change-password-input ${errors.newPassword ? 'willow-change-password-input-error' : ''}`}
//                         disabled={loading}
//                       />
//                       <button
//                         type="button"
//                         className="willow-change-password-toggle-btn"
//                         onClick={() => togglePasswordVisibility('new')}
//                         disabled={loading}
//                       >
//                         {showPassword.new ? <EyeOff size={18} /> : <Eye size={18} />}
//                       </button>
//                     </div>
                    
//                     {/* Password Strength Meter */}
//                     {formData.newPassword && (
//                       <div className="willow-change-password-strength">
//                         <div className="willow-change-password-strength-meter">
//                           <div 
//                             className="willow-change-password-strength-bar" 
//                             style={{
//                               width: `${passwordStrength()}%`,
//                               backgroundColor: getPasswordStrengthColor()
//                             }}
//                           />
//                         </div>
//                         <div className="willow-change-password-strength-label">
//                           <span>Password Strength: </span>
//                           <span style={{ color: getPasswordStrengthColor() }}>
//                             {passwordStrength() <= 40 ? 'Weak' : 
//                              passwordStrength() <= 80 ? 'Medium' : 'Strong'}
//                           </span>
//                         </div>
//                       </div>
//                     )}

//                     {errors.newPassword && (
//                       <span className="willow-change-password-error-msg">{errors.newPassword}</span>
//                     )}
//                   </div>

//                   {/* Confirm Password */}
//                   <div className="willow-change-password-form-group">
//                     <label htmlFor="confirmPassword" className="willow-change-password-label">
//                       <Lock size={16} />
//                       Confirm New Password
//                     </label>
//                     <div className="willow-change-password-input-wrapper">
//                       <input
//                         type={showPassword.confirm ? "text" : "password"}
//                         id="confirmPassword"
//                         name="confirmPassword"
//                         value={formData.confirmPassword}
//                         onChange={handleInputChange}
//                         placeholder="Re-enter your new password"
//                         className={`willow-change-password-input ${errors.confirmPassword ? 'willow-change-password-input-error' : ''}`}
//                         disabled={loading}
//                       />
//                       <button
//                         type="button"
//                         className="willow-change-password-toggle-btn"
//                         onClick={() => togglePasswordVisibility('confirm')}
//                         disabled={loading}
//                       >
//                         {showPassword.confirm ? <EyeOff size={18} /> : <Eye size={18} />}
//                       </button>
//                     </div>
//                     {errors.confirmPassword && (
//                       <span className="willow-change-password-error-msg">{errors.confirmPassword}</span>
//                     )}
//                   </div>

//                   {/* Submit Button */}
//                   <button 
//                     type="submit" 
//                     className="willow-change-password-submit-btn"
//                     disabled={loading}
//                   >
//                     {loading ? (
//                       <>
//                         <div className="willow-change-password-spinner"></div>
//                         <span>Changing Password...</span>
//                       </>
//                     ) : (
//                       <>
//                         <Shield size={18} />
//                         <span>Change Password</span>
//                       </>
//                     )}
//                   </button>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ChangePassword;


import React, { useState,useEffect } from 'react';
import { Lock, Eye, EyeOff, CheckCircle, XCircle, Shield } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify'; // Import toast

import '../../Dashboard Style/ChangePassword.css';
import Sidebar from '../Core/Sidebar';
import Navbar from '../Core/Navbar';
import { useSelector } from 'react-redux';
import { changePasswordApi } from '../../Services/Operations/ProductAPI';

const ChangePassword = () => {
  const token = useSelector((state) => state.user?.token);
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [showPassword, setShowPassword] = useState({
    current: false,
    new: false,
    confirm: false
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState('');
  const [success, setSuccess] = useState(false);
  
  // Password strength criteria
  const [passwordCriteria, setPasswordCriteria] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false
  });

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

      const [isMobile, setIsMobile] = useState(false);
  
    // Check screen size on mount and resize
    useEffect(() => {
      const checkMobile = () => {
        const mobile = window.innerWidth < 992;
        setIsMobile(mobile);
  
        // Auto-close sidebar on mobile by default
        if (mobile) {
          setSidebarOpen(true);
        } else {
          setSidebarOpen(true);
        }
      };
  
      checkMobile();
      window.addEventListener('resize', checkMobile);
      return () => window.removeEventListener('resize', checkMobile);
    }, []);
  
  
  
    const closeSidebar = () => {
      if (isMobile) {
        setSidebarOpen(false);
      }
    };


  // Initialize sidebar functionality (same as in Dashboard)
  useEffect(() => {
    const sidebar = document.querySelector('.sidebar');
    const sidebarBody = document.querySelector('.sidebar-body');
    
    if (sidebar) {
      if (sidebarOpen) {
        sidebar.classList.remove('close');
      } else {
        sidebar.classList.add('close');
      }
    }
    
    // Add custom scrollbar to sidebar body
    if (sidebarBody) {
      sidebarBody.style.height = 'calc(100vh - 70px)';
      sidebarBody.style.overflowY = 'auto';
    }

    return () => {
      // Cleanup
    };
  }, [sidebarOpen]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear field error
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }

    // Validate password criteria for new password
    if (name === 'newPassword') {
      setPasswordCriteria({
        length: value.length >= 8,
        uppercase: /[A-Z]/.test(value),
        lowercase: /[a-z]/.test(value),
        number: /[0-9]/.test(value),
        specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(value)
      });
    }
  };

  const togglePasswordVisibility = (field) => {
    setShowPassword(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.currentPassword.trim()) {
      newErrors.currentPassword = 'Current password is required';
    }

    if (!formData.newPassword.trim()) {
      newErrors.newPassword = 'New password is required';
    } else if (formData.newPassword.length < 8) {
      newErrors.newPassword = 'Password must be at least 8 characters';
    } else if (!passwordCriteria.uppercase || 
               !passwordCriteria.lowercase || 
               !passwordCriteria.number || 
               !passwordCriteria.specialChar) {
      newErrors.newPassword = 'Password does not meet all requirements';
    }

    if (!formData.confirmPassword.trim()) {
      newErrors.confirmPassword = 'Please confirm your password';
    } else if (formData.confirmPassword !== formData.newPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setApiError('');
  //   setSuccess(false);

  //   if (!validateForm()) {
  //     return;
  //   }

  //   setLoading(true);

  //   try {
  //     const formBody = new URLSearchParams({
  //       current_password: formData.currentPassword,
  //       new_password: formData.newPassword,
  //       confirm_password: formData.confirmPassword
  //     });

  //     const response = await fetch('https://global.thewillowquantum.com/api/user/change-password', {
  //       method: 'POST',
  //       headers: {
  //         'Authorization': `Bearer ${token}`,
  //         'Accept': 'application/json',
  //         'Content-Type': 'application/x-www-form-urlencoded',
  //       },
  //       body: formBody
  //     });

  //     const result = await response.json();

  //     if (result.status) {
  //       setSuccess(true);
  //       setFormData({
  //         currentPassword: '',
  //         newPassword: '',
  //         confirmPassword: ''
  //       });
  //       setPasswordCriteria({
  //         length: false,
  //         uppercase: false,
  //         lowercase: false,
  //         number: false,
  //         specialChar: false
  //       });
        
  //       // Show success toast
  //       toast.success('Password changed successfully! Redirecting to profile...');
        
  //       // Auto redirect after 3 seconds
  //       setTimeout(() => {
  //         setSuccess(false);
  //         navigate('/profile');
  //       }, 3000);
  //     } else {
  //       const errorMsg = result.message || 'Failed to change password. Please try again.';
  //       setApiError(errorMsg);
  //       toast.error(errorMsg);
  //     }
  //   } catch (error) {
  //     console.error('Password change error:', error);
  //     const errorMsg = 'An error occurred. Please try again.';
  //     setApiError(errorMsg);
  //     toast.error(errorMsg);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError('');
    setSuccess(false);

    if (!validateForm()) {
        return;
    }

    setLoading(true);

    try {
        const result = await changePasswordApi(token, {
            currentPassword: formData.currentPassword,
            newPassword: formData.newPassword,
            confirmPassword: formData.confirmPassword
        });

        if (result.status) {
            setSuccess(true);
            setFormData({
                currentPassword: '',
                newPassword: '',
                confirmPassword: ''
            });
            setPasswordCriteria({
                length: false,
                uppercase: false,
                lowercase: false,
                number: false,
                specialChar: false
            });
            
            // Show success toast
            toast.success(result.message || 'Password changed successfully! Redirecting to profile...');
            
            // Auto redirect after 3 seconds
            setTimeout(() => {
                setSuccess(false);
                navigate('/profile');
            }, 3000);
        } else {
            const errorMsg = result.message || 'Failed to change password. Please try again.';
            setApiError(errorMsg);
            toast.error(errorMsg);
        }
    } catch (error) {
        console.error('Password change error:', error);
        const errorMsg = 'An error occurred. Please try again.';
        setApiError(errorMsg);
        toast.error(errorMsg);
    } finally {
        setLoading(false);
    }
};

  const passwordStrength = () => {
    const metCriteria = Object.values(passwordCriteria).filter(Boolean).length;
    const totalCriteria = Object.keys(passwordCriteria).length;
    return (metCriteria / totalCriteria) * 100;
  };

  const getPasswordStrengthColor = () => {
    const strength = passwordStrength();
    if (strength <= 40) return '#ef4444';
    if (strength <= 80) return '#f59e0b';
    return '#10b981';
  };

  return (
   <div className="main-wrapper dark-theme">
      {/* Sidebar */}
      <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
        <div className="sidebar-header">
          <a href="#" className="sidebar-brand">
            <i className="me-2" data-lucide="atom"></i>
            Willow <span>Quantum</span>
          </a>
          <div className="sidebar-toggler" onClick={toggleSidebar}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <Sidebar
                   isOpen={!sidebarOpen}
                   onClose={closeSidebar}
                 />
       
                 {/* Mobile backdrop */}
                 {isMobile && sidebarOpen && (
                   <div
                     className="sidebar-backdrop"
                     onClick={closeSidebar}
                   />
                 )}
      </nav>

      <div className="page-wrapper">
        <Navbar toggleSidebar={toggleSidebar}  isSidebarOpen={sidebarOpen}
            isMobile={isMobile}/>

        
        {/* Page Content */}
        <div className="page-content-wrapper">
          <div className="willow-change-password-page">
            <div className="willow-change-password-container">
              <div className="willow-change-password-card">
                {/* Header */}
                <div className="willow-change-password-header">
                  <div className="willow-change-password-header-icon">
                    <Shield size={32} />
                  </div>
                  <h1 className="willow-change-password-title">Change Password</h1>
                  <p className="willow-change-password-subtitle">
                    Secure your account by updating your password regularly
                  </p>
                </div>

                {/* Success Message */}
                {success && (
                  <div className="willow-change-password-success-alert">
                    <CheckCircle size={20} />
                    <div>
                      <strong>Password Changed Successfully!</strong>
                      <p>You will be redirected to your profile page shortly.</p>
                    </div>
                  </div>
                )}

                {/* Error Message */}
                {apiError && (
                  <div className="willow-change-password-error-alert">
                    <XCircle size={20} />
                    <div>
                      <strong>Error</strong>
                      <p>{apiError}</p>
                    </div>
                  </div>
                )}

                {/* Form */}
                <form onSubmit={handleSubmit} className="willow-change-password-form">
                  {/* Current Password */}
                  <div className="willow-change-password-form-group">
                    <label htmlFor="currentPassword" className="willow-change-password-label">
                      <Lock size={16} />
                      Current Password
                    </label>
                    <div className="willow-change-password-input-wrapper">
                      <input
                        type={showPassword.current ? "text" : "password"}
                        id="currentPassword"
                        name="currentPassword"
                        value={formData.currentPassword}
                        onChange={handleInputChange}
                        placeholder="Enter your current password"
                        className={`willow-change-password-input ${errors.currentPassword ? 'willow-change-password-input-error' : ''}`}
                        disabled={loading}
                      />
                      <button
                        type="button"
                        className="willow-change-password-toggle-btn"
                        onClick={() => togglePasswordVisibility('current')}
                        disabled={loading}
                      >
                        {showPassword.current ? <EyeOff size={18} /> : <Eye size={18} />}
                      </button>
                    </div>
                    {errors.currentPassword && (
                      <span className="willow-change-password-error-msg">{errors.currentPassword}</span>
                    )}
                  </div>

                  {/* New Password */}
                  <div className="willow-change-password-form-group">
                    <label htmlFor="newPassword" className="willow-change-password-label">
                      <Lock size={16} />
                      New Password
                    </label>
                    <div className="willow-change-password-input-wrapper">
                      <input
                        type={showPassword.new ? "text" : "password"}
                        id="newPassword"
                        name="newPassword"
                        value={formData.newPassword}
                        onChange={handleInputChange}
                        placeholder="Create a strong new password"
                        className={`willow-change-password-input ${errors.newPassword ? 'willow-change-password-input-error' : ''}`}
                        disabled={loading}
                      />
                      <button
                        type="button"
                        className="willow-change-password-toggle-btn"
                        onClick={() => togglePasswordVisibility('new')}
                        disabled={loading}
                      >
                        {showPassword.new ? <EyeOff size={18} /> : <Eye size={18} />}
                      </button>
                    </div>
                    
                    {/* Password Strength Meter */}
                    {formData.newPassword && (
                      <div className="willow-change-password-strength">
                        <div className="willow-change-password-strength-meter">
                          <div 
                            className="willow-change-password-strength-bar" 
                            style={{
                              width: `${passwordStrength()}%`,
                              backgroundColor: getPasswordStrengthColor()
                            }}
                          />
                        </div>
                        <div className="willow-change-password-strength-label">
                          <span>Password Strength: </span>
                          <span style={{ color: getPasswordStrengthColor() }}>
                            {passwordStrength() <= 40 ? 'Weak' : 
                             passwordStrength() <= 80 ? 'Medium' : 'Strong'}
                          </span>
                        </div>
                      </div>
                    )}

                    {errors.newPassword && (
                      <span className="willow-change-password-error-msg">{errors.newPassword}</span>
                    )}
                  </div>

                  {/* Confirm Password */}
                  <div className="willow-change-password-form-group">
                    <label htmlFor="confirmPassword" className="willow-change-password-label">
                      <Lock size={16} />
                      Confirm New Password
                    </label>
                    <div className="willow-change-password-input-wrapper">
                      <input
                        type={showPassword.confirm ? "text" : "password"}
                        id="confirmPassword"
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleInputChange}
                        placeholder="Re-enter your new password"
                        className={`willow-change-password-input ${errors.confirmPassword ? 'willow-change-password-input-error' : ''}`}
                        disabled={loading}
                      />
                      <button
                        type="button"
                        className="willow-change-password-toggle-btn"
                        onClick={() => togglePasswordVisibility('confirm')}
                        disabled={loading}
                      >
                        {showPassword.confirm ? <EyeOff size={18} /> : <Eye size={18} />}
                      </button>
                    </div>
                    {errors.confirmPassword && (
                      <span className="willow-change-password-error-msg">{errors.confirmPassword}</span>
                    )}
                  </div>

                  {/* Submit Button */}
                  <button 
                    type="submit" 
                    className="willow-change-password-submit-btn"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <div className="willow-change-password-spinner"></div>
                        <span>Changing Password...</span>
                      </>
                    ) : (
                      <>
                        <Shield size={18} />
                        <span>Change Password</span>
                      </>
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;